import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLogout } from "../../hooks/useLogout";
import {
  useGetClinicDetails,
  useGetProfileStatus,
  useGetProviderDetails,
} from "../../hooks/useProvider";
import assets from "../../utils/Assets";
import OTPVerificationContainer from "../otpVerification/OTPVerificationContainer";
import MainMenu from "./MainMenu";
import MainMenuVideo from "./MainMenuVideo"
import ProviderLoginMenuItems from "./ProviderLoginMenuItems";
import SidebarMenu from "./SidebarMenu";
import withClickOutside from "./withClickOutside";

const ProviderMenuVideo = React.forwardRef(({ setOpen, open }, ref) => {
 const { mutateAsync: logoutMutate } = useLogout();
  const useAuth = () => {
    const user = localStorage.getItem("userID");
    return Boolean(user);
  };
  const user = useAuth();
  const location = useLocation();
  const navigation = useNavigate();

  const { data: providerData } = useGetProviderDetails(
    localStorage.getItem("userID") ? localStorage.getItem("userID") : ""
  );
  const { data: profileCompletionData } = useGetProfileStatus(
    localStorage.getItem("userID")
  );
  const { data: clinicData } = useGetClinicDetails(
    providerData?.provider?.providerId
  );

  useEffect(() => {
    if (clinicData?.status === "SUCCESS" && clinicData?.clinicProvider) {
      localStorage?.setItem(
        "clinicId",
        clinicData?.clinicProvider[0]?.clinicId
      );
    }
  }, [clinicData]);
  const logout = async() => {
     try {
    const response = await logoutMutate();

    if (response?.status === "SUCCESS") {
      localStorage.removeItem("auth");
    }

    localStorage.removeItem("userID");
    localStorage.removeItem("providerId");
    localStorage.removeItem("clinicId");
    localStorage.removeItem("expires_in");
    localStorage.removeItem("isSCAdmin");
    localStorage.removeItem("refresh_token");

   
      navigation("/login");
    

    setOpen(false);
  } catch (err) {
    console.error("Logout failed", err);
  }
  };

  useEffect(() => {
    if (providerData?.status === "SUCCESS") {
      localStorage.setItem("providerId", providerData?.provider?.providerId);
      localStorage.setItem("providerUn", providerData?.provider?.userName);
      localStorage.setItem(
        "isSCAdmin",
        providerData?.provider?.secondOpinionAdmin
      );
    }
  }, [providerData]);

  return (
    <>
    <div
  style={{
    display: "flex",
    flexDirection: "column", // 👈 makes children vertical
    alignItems: "center",    // 👈 center horizontally
    height: "80px",
    justifyContent: "center", // 👈 center vertically in 70px height
    backgroundColor:"#DDE9E9"
  }}
>
  <div
    style={{
      display: "flex",
      justifyContent: "center"
    }}
  >
    <img
      src="https://static.meragoapp.com/meragotest/merago-ai-hero.png"
      alt="Welcome"
      className="register__text"
      style={{ width: "180px", marginTop: "10px", height: "48px" }}
    />
  </div>

  <p
    className="register__text"
    style={{ color: "#557876", fontSize: "16px", margin: 0 }}
  >
    Your intelligent virtual assistant​
  </p>
</div>
    </>
  );
});

export default withClickOutside(ProviderMenuVideo);
